import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
        <Path fill="#F7FCFF" d="M0 0v4h16V0H0Z" />
        <Path fill="#E22C18" d="M0 8v4h16V8H0Z" />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
